module.exports = __webpack_public_path__ + "static/clients-image-3-3a8795e03c8d8cd60370baf1189aa78c.png";